import moment from 'moment-timezone';
import AppModel from '../DataModel/AppModel';
import {uiMsg} from './Languages';

export function dateAndTime(d) {
    if(!d) return uiMsg('TF_NO_TIMESTAMP',"No timestamp");
    return moment(d).tz(AppModel.time_zone).locale(AppModel.locale).format("LLLL");
}

export function dateStr(d) {
    if(!d) return uiMsg('TF_NO_DATE',"No date");
    return moment(d).tz(AppModel.time_zone).locale(AppModel.locale).format("LL");
}

export function timeStr(d) {
    if(!d) return uiMsg('TF_NO_TIMESTAMP',"No timestamp");
    return moment(d).tz(AppModel.time_zone).locale(AppModel.locale).format("LT");
}



/** WEBPACK FOOTER **
 ** ./src/utils/TimeFormatter.js
 **/